export type EventPeriodScope = "month" | "year" | "all";
export interface EventPeriod {
  scope: EventPeriodScope;
  month: number;
  year: number;
}
export type CalendarEventType = "all" | "DSU" | "partner";
export interface EventCalendarQuery {
  page: number;
  pageSize: number;
  search: string;
  status: "upcoming" | "past";
  period: EventPeriod;
  eventType: CalendarEventType;
}

const calendarDate = (year: number, month: number, day: number): string =>
  `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

export const buildEventCalendarQuery = (
  query: EventCalendarQuery,
  now = new Date()
): URLSearchParams => {
  const params = new URLSearchParams();
  params.set("pagination[page]", String(query.page));
  params.set("pagination[pageSize]", String(query.pageSize));
  params.set("sort[0]", query.status === "past" ? "start_date:desc" : "start_date:asc");
  params.set("sort[1]", "id:desc");

  const today = calendarDate(now.getFullYear(), now.getMonth(), now.getDate());
  let start: string;
  let end: string;
  if (query.period.scope === "year") {
    start = calendarDate(query.period.year, 0, 1);
    end = calendarDate(query.period.year + 1, 0, 1);
  } else if (query.period.scope === "month") {
    const { year, month } = query.period;
    start = calendarDate(year, month, 1);
    end = month === 11 ? calendarDate(year + 1, 0, 1) : calendarDate(year, month + 1, 1);
  }

  // Match events overlapping the chosen period, including multi-day events.
  if (end) params.set("filters[start_date][$lt]", end);
  if (query.status === "upcoming") {
    params.set("filters[end_date][$gte]", start && start > today ? start : today);
  } else {
    params.set("filters[end_date][$lt]", today);
    if (start) params.set("filters[end_date][$gte]", start);
  }

  if (query.eventType !== "all") {
    params.set("filters[partner_event][$eq]", String(query.eventType === "partner"));
  }
  if (query.search.trim()) {
    ["title", "city", "partener"].forEach((field, index) => {
      params.set(`filters[$or][${index}][${field}][$containsi]`, query.search.trim());
    });
  }
  return params;
};
